// @ts-ignore
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import { arrow_icon, delete_icon } from "../../../assets/img";
import { toast } from "react-toastify";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { checkPermission } from "../../redux/api/PermissionManager";

const MMC = () => {
  // @ts-ignore
  const navigate = useNavigate();
  const [data, setData] = useState({
    amount: "",
    gst: "",
    plan: "",
    total: "",
    policies: [],
    pointNames: [],
  });
  const [policy, setPolicy] = useState("");
  const [points, setPoints] = useState("");
  const [edit, setEdit] = useState();

  const handleChange = (target) => {
    const { name, value } = target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (data?.policies?.length === 0) {
      toast.error("Terms and Conditions should not be empty");
      return;
    }
    if (data?.pointNames?.length === 0) {
      toast.error("Points should not be empty");
      return;
    }
    const payload = {
      points: data.pointNames,
      terms_conditions: data.policies,
    };
    // new FormData();
    // payload.append("points", data.pointNames);
    // payload.append("terms_conditions", data.policies);
    const res = await post(URLS.MMC_MASTER + "update/", payload);
    console.log("mmc upload res", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      setEdit(false);
    }
  };

  useEffect(() => {
    viewMmc();
  }, []);

  const viewMmc = async () => {
    const res = await get(URLS.MMC_MASTER);
    console.log("view mmc", res);
    if (res?.status === "success") {
      let d = res?.data;
      setData({
        amount: d?.amount,
        gst: d?.gst,
        plan: d?.plan_days,
        total: d?.total_amount,
        pointNames: d?.points,
        policies: d?.terms_conditions,
      });
    }
  };

  // @ts-ignore
  const handlePolicies = (type, value) => {
    if (type === "add" && data.policies?.includes(value)) {
      toast.error("This Policy is already Added..");
      return;
    } // @ts-ignore
    setData((prev) => ({
      ...prev,
      policies:
        type === "add"
          ? [...prev.policies, value]
          : prev.policies.filter((item) => item !== value),
    }));
    setPolicy("");
  };

  const handlePointName = (type, value) => {
    if (type === "add" && data.pointNames?.includes(value.trim())) {
      toast.error("This point is already Added..");
      return;
    }
    // @ts-ignore
    setData((prev) => ({
      ...prev,
      pointNames:
        type === "add"
          ? [...prev.pointNames, value]
          : prev.pointNames.filter((item) => item !== value),
    }));
    setPoints("");
  };
  return (
    <div>
      <Topbar header={"Master"} subHead={"MMC"} />
      <div className="d-flex ac-je">
        {checkPermission("CAN-EDIT-MASTERMMC") && (
          <button
            onClick={() => setEdit(!edit)}
            className={`f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 submit-btn`}
            style={{ minWidth: "100px" }}
          >
            {edit ? "Cancel" : "Edit"}
          </button>
        )}
      </div>
      <div className="d-flex flex-wrap ae-js gap-4">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Amount
          </p>
          <input
            className="input-box"
            name="amount"
            disabled
            value={data.amount}
            onChange={(e) => handleChange(e.target)}
            type="text"
            placeholder="Amount"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            GST %
          </p>
          <input
            className="input-box"
            name="gst"
            disabled
            value={data.gst}
            onChange={(e) => handleChange(e.target)}
            type="text"
            placeholder="GST"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Plan Days
          </p>
          <input
            className="input-box"
            name="plan"
            disabled
            value={data.plan}
            onChange={(e) => handleChange(e.target)}
            type="text"
            placeholder="Plan"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Total Amount{" "}
          </p>
          <input
            className="input-box"
            name="total"
            disabled
            value={data.total}
            onChange={(e) => handleChange(e.target)}
            type="text"
            placeholder="Amount"
          />
        </div>
      </div>
      <div className="col-md-7 mt-5">
        <div className="d-flex ac-jb mb-3">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            Terms & Condition <span style={{ color: "red" }}>*</span>
          </p>
        </div>
        <div>
          <textarea
            readOnly={!edit}
            value={policy}
            onChange={(e) => setPolicy(e.target.value)}
            placeholder="Terms & Condition"
            className="input-border1 "
          />
        </div>
        {edit && (
          <div className="d-flex ac-je">
            <button
              // @ts-ignore
              onClick={() => {
                handlePolicies("add", policy);
              }}
              className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14  "
              style={{ minWidth: "100px" }}
            >
              Add
            </button>
          </div>
        )}
        <div>
          {data?.policies?.length > 0 && (
            <ul>
              {data?.policies?.map((policy, index) => {
                return (
                  <li className="d-flex as-js gap-3 my-3" key={index}>
                    <img
                      // @ts-ignore
                      src={arrow_icon}
                      className="back-arrow"
                      alt=""
                    />
                    <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 col-md-10">
                      {policy}
                    </p>
                    {edit && (
                      <img
                        // @ts-ignore
                        src={delete_icon}
                        className="edit-btn"
                        onClick={() => {
                          handlePolicies("delete", policy);
                        }}
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      <div className="col-md-7 mt-5">
        <div className="d-flex ac-jb mb-3">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            Points <span style={{ color: "red" }}>*</span>{" "}
          </p>
        </div>
        <div>
          <textarea
            readOnly={!edit}
            // maxLength={250}
            value={points}
            onChange={(e) => setPoints(e.target.value)}
            placeholder="Points"
            // onKeyPress={handleKeyPress}
            className="input-border1 "
          />
        </div>
        {edit && (
          <div className="d-flex ac-je">
            <button
              // @ts-ignore
              onClick={() => handlePointName("add", points)}
              className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14  "
              style={{ minWidth: "100px" }}
            >
              Add
            </button>
          </div>
        )}
        <div>
          {data?.pointNames?.length > 0 && (
            <ul>
              {data?.pointNames?.map((name, index) => {
                return (
                  <li className="d-flex as-js gap-3 my-3" key={index}>
                    <img
                      // @ts-ignore
                      src={arrow_icon}
                      className="back-arrow"
                      alt=""
                    />
                    <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 col-md-10">
                      {name}
                    </p>
                    {edit && (
                      <img
                        // @ts-ignore
                        src={delete_icon}
                        className="edit-btn"
                        onClick={() => {
                          handlePointName("delete", name);
                        }}
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      {edit && (
        <button
          onClick={handleSubmit}
          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-5"
        >
          Submit
        </button>
      )}
    </div>
  );
};
export default MMC;
